import { render } from "./CardCalendar.vue?vue&type=template&id=aeed2450"
import script from "./CardCalendar.vue?vue&type=script&lang=js"
export * from "./CardCalendar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__